import React from 'react';
import { StarIcon, UserIcon } from 'lucide-react';
import { RichText } from './RichText';
import { testimonials } from '../../data/landing';
function Stars({
  size = 'h-4 w-4'
}: {
  size?: string;
}) {
  return <span className="flex gap-0.5" aria-hidden="true" data-id="element-222" data-mp="3cs8culxsdizk">
      {Array.from({
      length: 5
    }).map((_, i) => <StarIcon key={i} className={`${size} fill-[#E8B04B] text-[#E8B04B]`} data-id="element-223" data-mp="38sg345wnp6sm" data-mpi={i} />)}
    </span>;
}
export function Testimonials() {
  return <section aria-labelledby="testimonials-title" className="bg-paper py-16 md:py-24" data-id="element-224" data-mp="99x9yasf3awu">
      <div className="mx-auto max-w-6xl px-5" data-id="element-225" data-mp="4b3uictkl9u1">
        <div className="mx-auto max-w-2xl text-center" data-id="element-226" data-mp="atpb2dlqng8">
          <h2 id="testimonials-title" className="font-serif text-[2.1rem] leading-[1.08] text-ink md:text-5xl" data-id="element-227" data-mp="dfwv20ht2yg">
            Lo que dicen las colegas que ya lo usan.
          </h2>
          <div className="mt-5 flex flex-wrap items-center justify-center gap-3 text-muted" data-id="element-228" data-mp="2l35axctdgkq3">
            <Stars size="h-5 w-5" data-id="element-229" data-mp="2g169i8h6zxvs" />
            <span data-id="element-230" data-mp="fzc0e34d1egh">
              <RichText text="[CALIFICACIÓN] · [CANTIDAD DE OPINIONES]" data-id="element-231" data-mp="fytyoqyxi816" />
            </span>
          </div>
        </div>

        <ul className="mt-12 grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-232" data-mp="kxdgqgaeizo9">
          {testimonials.map((t, i) =>
        // TESTIMONIO DEMO — REEMPLAZAR ANTES DE PUBLICAR (ver data/landing.ts)
        <li key={i} className="flex flex-col rounded-3xl border border-line bg-cream p-7" data-id="element-233" data-mp="bwp1xjd6ovab" data-mpi={i}>
              <div className="flex items-center justify-between gap-3" data-id="element-234" data-mp="3td6zl1s7gn8h">
                <Stars data-id="element-235" data-mp="1zas42lrn4qz" />
                {t.isDemo && <span className="rounded-md bg-accent-soft px-1.5 py-0.5 text-[10px] font-bold uppercase tracking-wide text-accent-dark" title="Testimonio demo — reemplazar antes de publicar" data-id="element-236" data-mp="20vmns82ynou">
                    Demo
                  </span>}
              </div>
              <blockquote className="mt-5 text-[17px] leading-relaxed text-ink" data-id="element-237" data-mp="3fe79dpp1o0a7">“{t.quote}”</blockquote>
              <div className="mt-auto flex items-center gap-3 pt-7" data-id="element-238" data-mp="1kys6e3x6equv">
                <span className="flex h-11 w-11 items-center justify-center rounded-full bg-primary text-white" data-id="element-239" data-mp="1l03a63qmfylz">
                  <UserIcon className="h-5 w-5" aria-hidden="true" data-id="element-240" data-mp="1c5ova2a06q3e" />
                </span>
                <div data-id="element-241" data-mp="176u349q5bp6m">
                  <p className="text-[15px] font-bold text-ink" data-id="element-242" data-mp="177dj3kw8k3i0">
                    <RichText text={t.name} data-id="element-243" data-mp="1750skjcewktc" />
                  </p>
                  <p className="mt-0.5 text-sm text-muted" data-id="element-244" data-mp="23wkvo3evn29s">
                    <RichText text={t.role} data-id="element-245" data-mp="1zuzp0zsxrk81" />
                  </p>
                </div>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}